export type BubbleListItemLike = Record<string, unknown> & {
  key: string | number;
  role?: string;
  content?: unknown;
  status?: string;
  loading?: boolean;
  extraInfo?: Record<string, unknown>;
  className?: string;
  style?: Record<string, unknown>;
};

const bubbleSafeKeys = new Set([
  "key",
  "role",
  "content",
  "status",
  "loading",
  "extraInfo",
  "className",
  "style",
  "prefixCls",
  "styles",
  "classNames",
  "placement",
  "loadingRender",
  "editable",
  "typing",
  "streaming",
  "variant",
  "shape",
  "footerPlacement",
  "header",
  "footer",
  "avatar",
  "extra",
  "onTyping",
  "onTypingComplete",
  "onEditConfirm",
  "onEditCancel",
]);

export function sanitizeBubbleListItems<T extends BubbleListItemLike>(items: T[]): T[] {
  return items.map((item) => {
    const sanitized: Record<string, unknown> = {};
    Object.keys(item).forEach((key) => {
      if (bubbleSafeKeys.has(key)) sanitized[key] = item[key];
    });
    return sanitized as T;
  });
}
